import React from "react";
import PropTypes from "prop-types";

import CloseIcon from "components/icons/CloseIcon";

import { Box, IconButton, Typography } from "@mui/material";
import { DialogTitle as MuiDialogTitle } from "@mui/material";

const DialogTitle = ({ title, Icon, onClose }) => {
  return (
    <MuiDialogTitle>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {Icon 
          ? <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {Icon}
              <Typography variant="h6">
                {title}
              </Typography>
            </Box>
          : title}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
    </MuiDialogTitle>
  );
};

DialogTitle.propTypes = {
  title: PropTypes.string,
  Icon: PropTypes.node,
  onClose: PropTypes.func,
};

export default DialogTitle;
